import {createSelector, MemoizedSelector} from '@ngrx/store';
import {chacrasAdapter, ChacrasState} from './chacras.state';

import {FeaturesState, selectFeatures} from '../../../features.state';
import {Chacra} from "../../../../../chacra-core/models/chacra";

export const getError = (state: ChacrasState): any => state.error;

export const getIsLoading = (state: ChacrasState): boolean =>
  state.isLoading;

export const selectChacrasState = createSelector(selectFeatures,
  (state: FeaturesState) => state.chacras
);

export const selectAllChacras: (state: object) => Chacra[] = chacrasAdapter.getSelectors(
  selectChacrasState
).selectAll;

export const selectChacraById = (id: string) =>
  createSelector(
    selectAllChacras,
    (allChacras: Chacra[]) => {
      if (allChacras) {
        return allChacras.find(c => c.rendimientoId === id);
      } else {
        return null;
      }
    }
  );

export const selectChacrasError: MemoizedSelector<object, any> = createSelector(
  selectChacrasState,
  getError
);

export const selectChacrasIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectChacrasState,
  getIsLoading
);


export const selectChacrasChangePendiente = createSelector(
  selectChacrasState,
  state => state.changePendiente
);
